/* unplugin-vue-components disabled */import { render } from "./UserName.vue?vue&type=template&id=6fc88ef2&scoped=true"
import script from "./UserName.vue?vue&type=script&lang=js"
export * from "./UserName.vue?vue&type=script&lang=js"

import "./UserName.vue?vue&type=style&index=0&id=6fc88ef2&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc88ef2"]])

export default __exports__